import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components/macro'
import { Button as btn } from 'reactstrap'
import { theme, ifProp } from 'styled-tools'
import { media } from 'ui/rwd'
import { MdShare } from 'react-icons/md'

const Container = styled.div`
  display: flex;
`

const Overlay = styled.div`
  position: fixed;
  background-color: rgba(0, 0, 0, 0.6);
  height: 100vh;
  width: 100%;
  z-index: 101;
  top: 0;
  left: 0;
  transform: translate3d(0, 0, 2px);
`

const Menu = styled.div`
  position: absolute;
  top: 2.7em;
  right: 0.2em;
  z-index: 102;
  ${media.sm`
    display: flex;
    top: 0;
    left: 3em;
  `};
  transform: translate3d(0, 0, 2px);
`

const ActionItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  z-index: 9999;
  margin-top: 0.3rem;

  ${media.sm`
      margin-top 0;
      margin-left: 20px;
  `};

  &:nth-child(1) {
    z-index: 104;
  }
  &:nth-child(2) {
    z-index: 103;
  }
  &:nth-child(3) {
    z-index: 102;
  }
`

const Label = styled(btn)`
  flex: 1;
  min-width: 80px;
  padding: 0.4rem 0.6rem !important;
  font-size: 0.875rem !important;
  background: white;
  border: 1px solid black;
  z-index: 9999;
  margin-bottom: 0;
  margin-right: 1.1rem;
  ${media.sm`
    order:2;
    margin-right: 0;
    margin-left: 1.1rem;
  `};
`

const BtnCircle = styled(btn)`
  box-shadow: 2px 2px 9px 0px rgba(0, 0, 0, 0.3);
`

const ActionButton = styled(BtnCircle)`
  position: relative;
  line-height: 0.5 !important;
  ${media.sm`
    order:1;
    line-height: 0.5 !important;
  `};
`

const BtnCircleBase = ({ ismobile, ...props }) => <BtnCircle {...props} />
BtnCircleBase.propTypes = {
  ismobile: PropTypes.bool
}

const storeThemeColored = css`
  background-color: ${theme('headerBackgroundColor', 'white')} !important;
  color: ${theme('storeName', 'black')} !important;
`
const ButtonDots = styled(BtnCircleBase)`
  z-index: 102;
  position: relative;
  box-shadow: none;
  font-size: ${ifProp('ismobile', '1.3em', '1rem')} !important;
  margin-left: ${ifProp('ismobile', '0.3em', '0')} !important;
  background: ${theme('white')} !important;
  color: ${theme('black')} !important;
  ${ifProp('ismobile', storeThemeColored)}
`

const ButtonShare = styled(btn)`
  margin-right: 1rem;
  position: relative;
  padding-left: 4rem !important;
  padding-right: 4rem !important;
  color: ${theme('productPlusButtonIcon', 'black')} !important;
  background: ${theme('productPlusButtonBackground', 'black')} !important;
`

const ButtonShareCircle = styled(btn)`
  position: relative;
  font-size: 1em !important;
  * {
    margin-left: -3px;
  }
  ${ifProp('ismobile', storeThemeColored)}
`

const ReportActionItem = styled(ActionItem)`
  ${media.sm`
    display: none !important;
  `};
`

const ShareIcon = styled(MdShare)`
  position: absolute;
  top: 50%;
  left: 1rem;
  transform: translateY(-50%);
`

export {
  Container,
  ButtonShareCircle,
  Label,
  ActionItem,
  Menu,
  Overlay,
  ActionButton,
  ButtonShare,
  ButtonDots,
  ShareIcon,
  ReportActionItem
}
